import type React from 'react';

import { NounSubtypeKey } from '../../filters/universal-type';
import { GoogleArchiveResultIcon } from '../../icons/google-archive';
import { GoogleAudioResultIcon } from '../../icons/google-audio';
import { GoogleDocumentResultIcon } from '../../icons/google-document';
import { GoogleDrawingResultIcon } from '../../icons/google-drawing';
import { GoogleFolderResultIcon } from '../../icons/google-folder';
import { GoogleImageResultIcon } from '../../icons/google-image';
import { GooglePdfResultIcon } from '../../icons/google-pdf';
import { GooglePresentationResultIcon } from '../../icons/google-presentation';
import { GoogleShortcutResultIcon } from '../../icons/google-shortcut';
import { GoogleSiteResultIcon } from '../../icons/google-site';
import { GoogleSpreadsheetResultIcon } from '../../icons/google-spreadsheet';
import { GoogleVideoResultIcon } from '../../icons/google-video';

/**
 * Returns the Google Drive file-type-specific icon for a given NounSubtype.
 */
export const getGoogleDriveFileTypeIcon = (
	subtype: string | null | undefined,
): (() => React.JSX.Element) | null => {
	switch (subtype) {
		case NounSubtypeKey.Folder:
			return GoogleFolderResultIcon;
		case NounSubtypeKey.Document:
			return GoogleDocumentResultIcon;
		case NounSubtypeKey.Spreadsheet:
			return GoogleSpreadsheetResultIcon;
		case NounSubtypeKey.Presentation:
			return GooglePresentationResultIcon;
		case NounSubtypeKey.Image:
			return GoogleImageResultIcon;
		case NounSubtypeKey.Pdf:
			return GooglePdfResultIcon;
		case NounSubtypeKey.Video:
			return GoogleVideoResultIcon;
		case NounSubtypeKey.Archive:
			return GoogleArchiveResultIcon;
		case NounSubtypeKey.Audio:
			return GoogleAudioResultIcon;
		case NounSubtypeKey.Design:
			return GoogleDrawingResultIcon;
		case NounSubtypeKey.Site:
			return GoogleSiteResultIcon;
		case NounSubtypeKey.Shortcut:
			return GoogleShortcutResultIcon;
		default:
			return null;
	}
};
